<template>
    <div class="column is-narrow is-flex-mobile has-text-centered is-horizontal-center">
        <figure class="image is-128x128">
            <router-link :to="'/auctions/models/' + brand.label">
                <img :src="'static/images/manufacturers/' + brand.label + '.png'">
                <span class="brand">{{ brand.label }}</span>
            </router-link>
        </figure>
    </div>
</template>

<script>
    export default {
        props: ['brand']
    }
</script>

<style scoped>
    .brand, .brand:link, .brand:hover, .brand:visited, .brand:active {
        color: grey;
    }
    .is-horizontal-center {
        justify-content: center;
    }

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Brand/TopBrand.vue